import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { EmployeeTable } from "./EmployeeTable";
import React from "react";
import { AxiosEmployeeAPI } from "../Api";
import { useQueryWithPagination } from "../../utils/Hooks";
import { PaginationButtons } from "../../common/components/PaginationButtons";

export const EmployeeInactiveList = ({ search }) => {
  const { isPending, data, error, handlePrevious, handleNext } =
    useQueryWithPagination({
      queryKey: ["employee-inactive-list", search],
      queryFn: AxiosEmployeeAPI.getAllAccessible,
      search: search,
      active: false,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <EmployeeTable employees={data.results} />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
